import HeroClaimsController from "./controllers/hero_claims_controller.mjs"
import { openSocialPopup } from "./social_popup.mjs"
import "@hotwired/turbo-rails"
import { Application, Controller } from "@hotwired/stimulus"
const application = Application.start()
application.register("hero-claims", HeroClaimsController)
application.register("clipboard", class extends Controller {
  static values = { text: String }
  async copy() { await navigator.clipboard.writeText(this.textValue); this.element.textContent = "Copied ✓" }
})
application.register("upload", class extends Controller {
  static targets = ["progress", "submit"]
  start(event) {
    if (!this.element.querySelector('input[name="campaign[original]"]')?.files.length) return
    event.preventDefault()
    event.stopImmediatePropagation()
    this.progressTarget.hidden = false
    this.submitTarget.disabled = true
    const request = new XMLHttpRequest()
    request.open("POST", this.element.action)
    request.setRequestHeader("X-CSRF-Token", document.querySelector('meta[name="csrf-token"]').content)
    request.setRequestHeader("Accept", "text/html")
    request.upload.onprogress = (e) => { if (e.lengthComputable) this.progressTarget.value = e.loaded / e.total * 100 }
    request.onload = () => {
      if (request.status < 400) { Turbo.visit(request.responseURL); return }
      this.submitTarget.disabled = false
      this.progressTarget.hidden = true
      const incoming = new DOMParser().parseFromString(request.responseText, "text/html").querySelector("main")
      const current = document.querySelector("main")
      if (incoming && current) { current.replaceWith(incoming); incoming.scrollIntoView({ block: "start" }) }
      else alert("Upload failed. Please check audio and form fields.")
    }
    request.onerror = () => { this.submitTarget.disabled = false; alert("Connection interrupted. Retry upload.") }
    request.send(new FormData(this.element))
  }
})

application.register("analytics", class extends Controller {
  static values = { url: String }
  preview() {
    if (this.sent) return
    this.sent = true
    fetch(this.urlValue, { method: "POST", headers: { "Content-Type": "application/json", "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').content }, body: JSON.stringify({kind: "preview_started"}) })
  }
})

application.register("social-popup", class extends Controller {
  static targets = ["status", "error"]
  open(event) {
    const form = event.currentTarget
    openSocialPopup(event, {
      openWindow: (...args) => window.open(...args),
      request: async () => {
        const response = await fetch(form.action, {
          method: "POST",
          credentials: "same-origin",
          headers: { "Accept": "application/json", "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').content },
          body: new FormData(form)
        })
        if (!response.ok || response.redirected) throw new Error("Support request failed")
        return response.json()
      },
      onStatus: (message) => { this.statusTarget.textContent = message },
      onError: () => { this.statusTarget.textContent = this.errorTarget.textContent }
    })
  }
})
